// extracted by mini-css-extract-plugin
module.exports = {"title":"InStoreDeliveryStoreSelector_title__XAHCc"};